module.exports = __webpack_public_path__ + "img/cursor-02.44fd3ae3.svg";